document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.product-main .product-gallery-wrap').forEach(function(wrap){
    var strip=wrap.querySelector('.product-gallery__thumbnails');
    if(!strip)return;
    strip.style.setProperty('margin-top','0','important');
    strip.style.setProperty('margin-bottom','0','important');
    var gallery=wrap.querySelector('.product-gallery');
    var slides=gallery?Array.from(gallery.querySelectorAll('.product-gallery__item')):[];
    slides.forEach(function(slide){
      slide.style.setProperty('height','100%','important');
      slide.style.setProperty('aspect-ratio','5 / 4','important');
      slide.style.setProperty('border','0','important');
      slide.style.setProperty('overflow','hidden','important');
      slide.querySelectorAll('picture').forEach(function(picture){picture.style.setProperty('display','block','important');picture.style.setProperty('width','100%','important');picture.style.setProperty('height','100%','important');picture.style.setProperty('border','0','important');});
      slide.querySelectorAll('img').forEach(function(image){image.style.setProperty('display','block','important');image.style.setProperty('width','100%','important');image.style.setProperty('height','100%','important');image.style.setProperty('max-height','100%','important');image.style.setProperty('object-fit','contain','important');image.style.setProperty('object-position','center','important');image.style.setProperty('border','0','important');image.style.setProperty('box-shadow','none','important');});
    });
    var heightFrame=0;
    function syncGalleryHeight(){
      if(!gallery||!slides.length)return;
      var index=gallery.clientWidth?Math.round(gallery.scrollLeft/gallery.clientWidth):0;
      index=Math.max(0,Math.min(index,slides.length-1));
      var width=Math.ceil(gallery.getBoundingClientRect().width);
      var height=Math.round(width*0.8);
      if(height>0)gallery.style.setProperty('height',height+'px','important');
    }
    function requestHeightSync(){cancelAnimationFrame(heightFrame);heightFrame=requestAnimationFrame(syncGalleryHeight);}
    slides.forEach(function(slide){var image=slide.querySelector('img');if(image&&!image.complete)image.addEventListener('load',requestHeightSync,{once:true});});
    if(gallery)gallery.addEventListener('scroll',requestHeightSync,{passive:true});
    strip.addEventListener('click',function(){setTimeout(requestHeightSync,80);setTimeout(requestHeightSync,350);});
    window.addEventListener('resize',requestHeightSync,{passive:true});
    function syncThumbnailFrames(){
      var size=window.matchMedia('(max-width:640px)').matches?'56px':'64px';
      strip.querySelectorAll('button').forEach(function(button){
        button.style.setProperty('box-sizing','border-box','important');
        button.style.setProperty('flex','0 0 '+size,'important');
        button.style.setProperty('width',size,'important');
        button.style.setProperty('min-width',size,'important');
        button.style.setProperty('max-width',size,'important');
        button.style.setProperty('height',size,'important');
        button.style.setProperty('min-height',size,'important');
        button.style.setProperty('max-height',size,'important');
        button.style.setProperty('padding','3px','important');
        button.style.setProperty('border','0','important');
        button.style.setProperty('outline','0','important');
        button.style.setProperty('box-shadow','none','important');
        button.style.setProperty('background','#fff','important');
        var image=button.querySelector('img');
        if(image){image.style.setProperty('border','0','important');image.style.setProperty('box-shadow','none','important');image.style.setProperty('background','#fff','important');}
      });
    }
    syncThumbnailFrames();
    window.addEventListener('resize',syncThumbnailFrames,{passive:true});
    var prev=document.createElement('button'),next=document.createElement('button');
    prev.type=next.type='button'; prev.className=next.className='utz-gallery-arrow';
    prev.dataset.galleryPrev=''; next.dataset.galleryNext='';
    prev.innerHTML='&#8249;'; next.innerHTML='&#8250;';
    prev.setAttribute('aria-label','Vorige miniaturen'); next.setAttribute('aria-label','Volgende miniaturen');
    wrap.append(prev,next);
    [prev,next].forEach(function(button){button.style.setProperty('border','0','important');button.style.setProperty('background','transparent','important');button.style.setProperty('box-shadow','none','important');});
    function update(){var overflow=strip.scrollWidth>strip.clientWidth+2;prev.classList.toggle('is-visible',overflow);next.classList.toggle('is-visible',overflow);prev.disabled=strip.scrollLeft<=2;next.disabled=strip.scrollLeft+strip.clientWidth>=strip.scrollWidth-2}
    prev.addEventListener('click',function(){strip.scrollBy({left:-strip.clientWidth*.75,behavior:'smooth'})});
    next.addEventListener('click',function(){strip.scrollBy({left:strip.clientWidth*.75,behavior:'smooth'})});
    strip.addEventListener('scroll',update,{passive:true}); window.addEventListener('resize',update,{passive:true}); update(); requestHeightSync();
  });
});

